import type { IncomingPayment } from '@tectonics/prs/incoming-payment';

export interface Address {
  readonly country: string;
  readonly zipcode: string | null;
  readonly state: string | null;
  readonly city: string | null;
  readonly street_name: string | null;
  readonly street_number: string | null;
  readonly street_complement: string | null;
}

export const getAddress = ({
  country,
  zipcode = null,
  state = null,
  city = null,
  address: street_name = null,
  street_number = null,
  street_complement = null,
}: IncomingPayment): Address => ({ country, zipcode, state, city, street_name, street_number, street_complement });
